export default {
  RUNTIME: 'runtime',
  WEB_SITE_ONLY: 'web-site-only',
};
